import { useCallback, useState } from 'react';
import HeaderAppBar from './HeaderAppBar';
import CascadeDrawer from '../drawer/CascadeDrawer';
import { DrawerItem } from '../drawer/ItemsDrawer';

export default function Header() {
  
  const [level, setLevel] = useState(0);
  const [historico, setHistorico] = useState<DrawerItem[] | []>([]);

  const [open, setOpen] = useState(false);

  const handleDrawerState = useCallback(() => {
      setOpen((r) => !r)
      setLevel(0);
      setHistorico([])
  },[setOpen,setLevel,setHistorico])

  return (
    <>
      <CascadeDrawer open={open} handleDrawerState={handleDrawerState} level={level} setLevel={setLevel} historico={historico} setHistorico={setHistorico} />
      <HeaderAppBar setOpenDrawer={setOpen} setLevel={setLevel} open={open} handleDrawerState={handleDrawerState} setHistorico={setHistorico}/>
    </>
  );
}
